import { Component, OnInit } from '@angular/core';
import { MapService } from "../../view/services/map.service";
import LayerList from "@arcgis/core/widgets/LayerList";
import Slider from "@arcgis/core/widgets/Slider";

@Component({
  selector: 'app-layers-list',
  templateUrl: './layers-list.component.html',
  styleUrls: ['./layers-list.component.css']
})
export class LayersListComponent implements OnInit {
  layerList: LayerList;

  constructor(public mapService: MapService) { }

  ngOnInit(): void {
    this.layerList = new LayerList({
      view: this.mapService.getViewMap(),
      container: 'divLayersList',
      listItemCreatedFunction: (event) => {
        const item = event.item;
        const slider = new Slider({
          min: 0,
          max: 100,
          values: [item.layer.opacity * 100],
          precision: 0,
        });

        item.panel = {
          content: ["Opacidad", slider],
          title: "Opacidad",
          className: "esri-icon-environment-settings"
        };

        slider.on("thumb-drag", (event) => {
          const { value } = event;
          item.layer.opacity = value / 100;
        });
      }
    });
  }

}
